export default __webpack_public_path__ + "static/media/restaurant-icon.a8a7e252.svg";